<template>
  <el-dialog v-loading="loading.dialog" class="toTest_model_dialog" top="5vh" center
    :title="'【' + formInfo.taskInfo.pid + '.' + formInfo.taskInfo.id + '】' + '待测试'" width="90%"
    :before-close="handleClose" :visible.sync="dialogVisible" :close-on-click-modal="false">
    <el-form size="mini" :model="form">
      <div style="display: flex">
        <el-form-item label="主域名" prop="domain" :label-width="formLabelWidth">
          {{ allSelect.TEXTDOMAINS[form.domain] }}
        </el-form-item>
        <el-form-item label="系统" label-width="65px">
          {{ allSelect.TEXTMODULES[form.module] }}
        </el-form-item>
      </div>
      <div style="display:flex;">
        <el-form-item label="产品" :label-width="formLabelWidth">
          {{ allSelect.TEXTUSERS[form.user_pm] }}
        </el-form-item>
        <el-form-item label="开发" label-width="65px">
          {{ allSelect.TEXTUSERS[form.user_rd] }}
        </el-form-item>
        <el-form-item label="测试" label-width="65px">
          {{ allSelect.TEXTUSERS[form.user_qa] }}
        </el-form-item>
        <el-form-item label="技术评审员" label-width="100px">
          {{ techReviewerCh }}
        </el-form-item>
      </div>
      <el-form-item v-if="!nonStandard" label="代码分支" :label-width="formLabelWidth">
        <div style="text-decoration: underline;color: #409EFF;cursor: pointer;" @click="openLink(form.branch_web_url_prefix + form.branch)">
          {{ form.branch }}
        </div>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button type="warning" :loading="loading.submit" @click="submit">开 始 测 试</el-button>
    </div>
  </el-dialog>
</template>
<script>
import {
  getDevOpsSpaceListStageParmApi,
  postDevopsSpaceStageActionApi,
} from "@/server/tops/devOps";
import { mapState } from "vuex";
export default {
  components: {},
  props: {
    formInfo: {
      type: Object,
      default: function () {
        return {};
      },
    },
    dialogVisible: {
      type: Boolean,
      default: function () {
        return false;
      },
    },
    hideDialogVisible: {
      type: Function,
      default: function () {
        return () => { };
      },
    },
  },
  data() {
    return {
      form: {
        domain: ""
      },
      formLabelWidth: "130px",
      loading: {
        submit: false,
        dialog: true
      }
    };
  },
  async created() {
    const {
      user_pm,
      user_qa,
      user_rd,
      id = "",
      pid = "",
      module = "",
      tech_reviewer = "",
      domain = ""
    } = this.formInfo?.taskInfo || {};
    this.form = { ...this.form, id, pid, user_pm, user_qa, user_rd, module, tech_reviewer, domain };
    await this.queryDevOpsSpaceListStageParmInfo();
  },
  computed: {
    ...mapState({
      allSelect: (state) => state.devOps.ALLSELECT,
    }),
    techReviewerCh() {
      let names = '';
      this.form.tech_reviewer.split(",").forEach((item) => {
        if (this.allSelect.TEXTUSERS[item]) {
          names += this.allSelect.TEXTUSERS[item] + ' '
        }
      })
      return names;
    },
    nonStandard() { // 非标系统标识
      return this.form.module.startsWith('非标-')
    }
  },
  methods: {
    // 获取开发中任务阶段设置信息
    async queryDevOpsSpaceListStageParmInfo() {
      try {
        const { id = "", pid = "" } = this.form;
        const ret = await getDevOpsSpaceListStageParmApi({
          stage_id: "5",
          task_id: id,
          pid,
        });
        if (ret.status === "success") {
          const { common_branch: branch, branch_web_url_prefix = '' } = ret.data || {};
          this.form = {
            ...this.form,
            branch,
            branch_web_url_prefix
          };
        } else {
          this.$notify({
            message: ret.error || "数据错误",
            type: "error",
          });
        }
      } catch (error) {
        this.$notify({
          message: error || "数据错误",
          type: "error",
        });
      } finally {
        this.loading.dialog = false;
      }
    },
    // 关闭弹窗
    handleClose(step) {
      this.hideDialogVisible(step);
    },
    // 打开外链接
    openLink(url) {
      window.open(url);
    },
    // 开始测试
    async submit() {
      try {
        this.loading.submit = true;
        const { id, pid, branch, user_pm, user_qa, user_rd, module } = this.form;
        const param = {
          action: "run",
          stage_id: "20",
          task_id: id,
          stage_name: "tester_testWaitTest",
          pid,
          branch,
          user_pm,
          user_qa,
          user_rd,
          module,
        };
        const ret = await postDevopsSpaceStageActionApi(param);
        let output = ret.data?.output || {};

        if (ret.status === 'success' && (typeof output !== 'string') && output?.codetest[0]?.code === 0) {
          this.handleClose('testEnvTesting')
        } else {
          this.$notify({
            message: typeof output === 'string' ? output : output?.applytest[0]?.msg,
            type: 'error'
          })
        }
      } catch (error) {
        this.$notify({
          message: error || '提测失败',
          type: 'error'
        })
      } finally {
        this.loading.submit = false;
      }

    },
  },
};
</script>
<style lang="scss">
.toTest_model_dialog {
  .el-dialog__body {
    padding-bottom: 0;
  }
}
</style>